import { render } from "./AiReportChat.vue?vue&type=template&id=09bf5b88&scoped=true&ts=true"
import script from "./AiReportChat.vue?vue&type=script&lang=ts"
export * from "./AiReportChat.vue?vue&type=script&lang=ts"

import "./AiReportChat.vue?vue&type=style&index=0&id=09bf5b88&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bf5b88"]])

export default __exports__